var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-item"},[_c('editor-header',{attrs:{"title":_vm.$t('builder.latest_updates'),"hasHelper":_vm.contentItem.has_helper}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }